module.exports = __webpack_public_path__ + "img/pda手持机.29ee01a3.jpg";